import AccountModule from "./account";
import GuestModule from "./guest";

export default { AccountModule, GuestModule };
